// @flow

import React, { type Node } from 'react';
import { useUniqueId } from '@tectonics/hooks';

import { useUserInputAsSelect } from '@tectonics/prs/user-input-values';
import { useSubmitting } from '@tectonics/prs/submitting';
import { useUserInputValidationError } from '@tectonics/prs/validation';
import { useFormHasBeenSent } from '@tectonics/prs/form-status';
import { useOpenedIncomingPayment, getSafeAchPseBankList } from '@tectonics/prs/incoming-payment';
import { Label, Select, SelectOption } from '../../../../commons/atoms';
import { Field } from '../../../../commons/molecules';
import { getSafePaymentOptionsV2 } from '@tectonics/prs/incoming-payment/get-payment-options';

export function AchPseBankList(): Node {
  const incomingPayment = useOpenedIncomingPayment();
  const [value, handleChange] = useUserInputAsSelect('selectedExternalPayProviderBank');
  const submitting = useSubmitting();

  const validationError = useUserInputValidationError('selectedExternalPayProviderBank');
  const formHasBeenSent = useFormHasBeenSent();

  const paymentOptions = getSafePaymentOptionsV2(incomingPayment);
  const bankList = getSafeAchPseBankList(paymentOptions);
  const inputId = useUniqueId();

  return (
    <Field
      data-test-name="payment-bank-code"
      label={<Label htmlFor={inputId}>Banco</Label>}
      hint="Serás redireccionado a la página de la banca en línea que selecciones"
      error="El Banco que seleccionaste no es válido."
      hasError={formHasBeenSent && !!validationError}
    >
      <Select id={inputId} value={value} onChange={handleChange} readOnly={submitting} name="payment-bank-code">
        <SelectOption key="" value="">
          Selecciona tu banco
        </SelectOption>
        {bankList.map((element, index) => (
          <SelectOption key={index} value={element.value}>
            {element.name}
          </SelectOption>
        ))}
      </Select>
    </Field>
  );
}
